import React from "react";
import {
  FileUploadImage,
  FromButton,
  InputBox,
  MediaSection,
  OrganizationForm,
  SpanText,
  SubTitle,
  SubTitleNumber,
  SubTitleText,
  SubTitlebtn,
} from "./EditProfileStyle";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import FileUploadIcon from "../../../assests/images/bold-gallery.svg";
import CameraIcon from "../../../assests/images/camera.svg";
import YouTubeIcon from "../../../assests/images/youtube.svg";
import { MESSAGE } from "../../../utils/message";
import { FieldArray, FormikErrors, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { MediaProfileProps } from "../../../utils/types";
import { uploadNonprofitMediaHandler } from "../../../redux/slices/myNonprofit/nonprofitMedia-slice";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const MediaProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();


  const dispatch = useDispatch();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      logo: {} as File,
      images: [] as Array<{ file: File; title: string }>,
      videos: [] as Array<{ url: string; description: string }>,
    },
    validationSchema: Yup.object({
      logo: Yup.mixed().required("File is required"),
      images: Yup.array()
        .of(
          Yup.object({
            file: Yup.mixed().required("File is required"),
            title: Yup.string().trim(),
          })
        ),
      videos: Yup.array().of(
        Yup.object({
          url: Yup.string().trim()
            .url("Please enter valid URL")
            .required(MESSAGE.requiredErrors("Video URL")),
          description: Yup.string().trim(),
        })
      ),
    }),
    onSubmit: (values: MediaProfileProps) => {
      if (id) {
        dispatch(uploadNonprofitMediaHandler(id, values) as any);
      }
    },
  });

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.length ? e.target.files[0] : undefined;
    if (file) {
      formik.setFieldValue("logo", file);
    }
  };


  return (
    <MediaSection>
      <SubTitle>
        <SubTitlebtn>
          <SubTitleNumber>02</SubTitleNumber>
          <SubTitleText>{MESSAGE.yourMedia}</SubTitleText> (Optional)
        </SubTitlebtn>
        <Button onClick={() => navigate(`/dashboard/gallery/${id}`)}>Edit via Media Gallery</Button>
      </SubTitle>

      <FormikProvider value={formik}>
        <OrganizationForm onSubmit={formik.handleSubmit}>
          <Row>
            <Col sm={12} md={12} lg={6}>
              <Form.Group className="upload-box">
                <Form.Label>{MESSAGE.uploadYourLogo}</Form.Label>
                <InputBox className="profile-upload upload-logo-img">
                  <label className="input-group-text" htmlFor="logo">
                    {MESSAGE.browse}
                  </label>
                  <Form.Control
                    type="file"
                    className="form-control upload-input"
                    id="logo"
                    name="logo"
                    onChange={handleFile}
                  />
                  {formik.values?.logo?.name}
                  <FileUploadImage>
                    <Image src={FileUploadIcon} />
                  </FileUploadImage>
                </InputBox>
                {formik.touched.logo && formik.errors.logo && (
                  <div className="error">
                    <p>{formik.errors.logo.toString()}</p>
                  </div>
                )}
              </Form.Group>
              <Form.Text className="text-media">
                {MESSAGE.fileLimit2MB}
              </Form.Text>
            </Col>
            <Col sm={12} md={12} lg={6}>
              <FieldArray
                name="images"
                render={({ push, remove }) => {
                  const handleImage = (
                    e: React.ChangeEvent<HTMLInputElement>
                  ) => {
                    const file = e.target.files?.length
                      ? e.target.files[0]
                      : undefined;
                    if (file) {
                      push({ file: file, title: "" });
                    }
                  };

                  return (
                    <>
                      <Form.Group className="upload-box">
                        <Form.Label>{MESSAGE.uploadPhotosNonprofit}</Form.Label>
                        <InputBox className="profile-upload upload-logo-img">
                          <label
                            className="input-group-text"
                            htmlFor="imageSelector"
                          >
                            {MESSAGE.browse}
                          </label>
                          <Form.Control
                            type="file"
                            id="imageSelector"
                            name="imageSelector"
                            className="form-control upload-input"
                            onChange={handleImage}
                          />
                          <FileUploadImage>
                            <Image src={CameraIcon} />
                          </FileUploadImage>
                        </InputBox>
                      </Form.Group>
                      {formik.values.images?.map((item, i) => (
                        <Row key={i + 1} className="mt-2">
                          <Col sm={12} md={12} lg={5}>
                            <Form.Group className="input-box">
                              <Form.Control
                                type="text"
                                disabled
                                value={
                                  formik.values.images.length ?
                                    formik.values.images[i]?.file.name : ""
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={12} md={12} lg={6}>
                            <Form.Group className="input-box">
                              <Form.Control
                                type="text"
                                placeholder="Add a Description"
                                value={formik.values.images[i]?.title}
                                id={`images[${i}].title`}
                                name={`images[${i}].title`}
                                onChange={(e) => formik.handleChange(e)}
                              />
                              {formik.touched.images &&
                                formik.touched.images[i]?.title &&
                                formik.errors.images ? formik.errors.images[i] && (
                                  <div className="error">
                                    <p>
                                      {formik.errors.images[i]
                                        ? (
                                          formik.errors
                                            .images as FormikErrors<{
                                              file: File;
                                              title: string;
                                            }>[]
                                        )[i].title
                                        : ""}
                                    </p>
                                  </div>
                                ) : <></>}
                            </Form.Group>
                          </Col>
                          <Col sm={12} md={12} lg={1}>
                            <Button
                              className="remove-button"
                              onClick={(e) => {
                                e.preventDefault();
                                remove(i);
                              }}
                            >
                              X
                            </Button>
                          </Col>
                        </Row>
                      ))}
                    </>
                  );
                }}
              />
              {formik.touched.images &&
                typeof formik.errors.images === "string" && (
                  <div className="error">
                    <p>{formik.errors.images}</p>
                  </div>
                )}
            </Col>
            <Col sm={12} md={12} lg={6}>
              <FieldArray
                name="videos"
                render={({ push, remove }) => {
                  return (
                    <>
                      <Form.Group
                        controlId="youtubeVideoLink"
                        className="upload-box"
                      >
                        <Form.Label>
                          {MESSAGE.uploadVideoNonprofit}{" "}
                          <SpanText>(Optional)</SpanText>
                        </Form.Label>
                        <InputBox className="profile-upload">
                          <Button
                            className="input-group-text"
                            onClick={() => {
                              push({ url: "", description: "" });
                            }}
                          >
                            {MESSAGE.add}
                          </Button>
                          <Form.Control
                            type="text"
                            className="form-control youtube-input"
                            placeholder="YouTube Video URL"
                            disabled
                          />
                          <FileUploadImage>
                            <Image src={YouTubeIcon} />
                          </FileUploadImage>
                        </InputBox>
                      </Form.Group>
                      {formik.values.videos?.map((item, i) => (
                        <Row key={i + 1} className="mt-2">
                          <Col sm={12} md={12} lg={5}>
                            <Form.Group className="input-box">
                              <Form.Control
                                type="text"
                                id={`videos[${i}].url`}
                                name={`videos[${i}].url`}
                                placeholder="Enter URL"
                                onChange={formik.handleChange}
                                className="videoimge"
                                value={
                                  formik.values.videos.length ? formik.values.videos[i]?.url : ""
                                }
                              />
                              {formik.touched.videos?.length && formik.touched.videos[i] && formik.touched.videos[i]?.url && formik.errors.videos?.length && formik.errors.videos[i] && (
                                <div className="error videoerror">
                                  <p>
                                    {formik.errors.videos[i]
                                      ? (
                                        formik.errors
                                          .videos as FormikErrors<{
                                            url: string;
                                            description: string;
                                          }>[]
                                      )[i].url
                                      : ""}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col sm={12} md={12} lg={6}>
                            <Form.Group className="input-box">
                              <Form.Control
                                type="text"
                                value={formik.values.videos[i]?.description}
                                id={`videos[${i}].description`}
                                name={`videos[${i}].description`}
                                placeholder="Enter Description"
                                onChange={formik.handleChange}
                              />
                              {formik.touched.videos &&
                                formik.touched.videos[i]?.description &&
                                formik.errors.videos?.length && formik.errors.videos[i] && (
                                  <div className="error">
                                    <p>
                                      {formik.errors.videos[i]
                                        ? (
                                          formik.errors
                                            .videos as FormikErrors<{
                                              url: string;
                                              description: string;
                                            }>[]
                                        )[i].description
                                        : ""}
                                    </p>
                                  </div>
                                )}
                            </Form.Group>
                          </Col>
                          <Col sm={12} md={12} lg={1}>
                            <Button
                              className="remove-button"
                              onClick={(e) => {
                                e.preventDefault();
                                remove(i);
                              }}
                            >
                              X
                            </Button>
                          </Col>
                        </Row>
                      ))}
                    </>
                  );
                }}
              />
            </Col>
            <FromButton>
              <Button className="btn-outline-success-blue" type="submit">
                {MESSAGE.saveChanges}
              </Button>
            </FromButton>
          </Row>
        </OrganizationForm>
      </FormikProvider>
    </MediaSection>
  );
};

export default MediaProfile;
